import { isNil, toNumber } from 'lodash-es';
export function appendZeros(value, decimalSeparator, precision) {
    if (!value.includes(decimalSeparator)) {
        value += decimalSeparator;
    }
    if (precision > value.split(decimalSeparator)[1].length) {
        return value + '0'.repeat(precision - value.split(decimalSeparator)[1].length);
    }
    else {
        return value;
    }
}
export function cutValueToPrecision(value, decimalSeparator, precision) {
    return value.substring(0, value.indexOf(decimalSeparator) + (precision ? precision + 1 : 0));
}
export function removeLastDecimalPoint(value, decimalSeparator) {
    return value.endsWith(decimalSeparator) ? value.slice(0, -1) : value;
}
export function shouldHandlePrecision(value, decimalSeparator, precision) {
    return (!isNil(precision) &&
        value.includes(decimalSeparator) &&
        value.split(decimalSeparator)[1].length > precision);
}
export function removeZeros(value, decimalSeparator) {
    const wholeNumber = value.split(decimalSeparator)[0];
    const fractionalPart = value.split(decimalSeparator)[1];
    return `${toNumber(wholeNumber)}${fractionalPart ? decimalSeparator + fractionalPart : ''}`;
}
